// extracted by mini-css-extract-plugin
export default {"offer":"offer___f7cf1b6e18145223cd48","subheader":"subheader___f6739bb7544c9b5686f1","content":"content___e12d9f610917f5d46754","htmlWrapper":"htmlWrapper___d975b6cfdf23bb2b3664"};